export const getDatadogEnv = () => import.meta.env.VITE_ENV?.trim().toLowerCase();
